import BossModel from "@/models/BossModel";

export default class PackageType extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'package/type';

    /**
     *
     * @type {string}
     */
    static entity = 'packageTypes';

    static PROPOSAL_ADD_TYPES = [
        'Rondreis',
        'Strandvakantie',
        'Starterspakketten',
    ];

    static fields() {
		return {
			id: this.number(null),
			name: this.attr(null),
			code: this.attr(null),
			is_active: this.boolean(null),
			url: this.attr(null),
		}
	}

    static getLabel(id) {
        const item = this.query().find(id);
        return item.code + ' - ' + item.name;
    }

    /**
     * @param params
     * @returns {*}
     */
    static fetchAllForSelect() {
        return this.api().limit(0).where('is_active', true).get(true);
    }

    static getIconByLetter(letter) {
        switch (letter) {
            case 'R' : {
                return 'mdi-routes'
            }
            case 'A' : {
                return 'mdi-umbrella-beach-outline'
            }
            case 'K' : {
                return 'mdi-ray-start-arrow'
            }
            default: {
                return 'mdi-circle-multiple-outline'
            }
        }
    }

    /**
     *
     * @returns {*}
     */
    static loadAll() {
        return this.api()
            .where('is_active', true)
            .get(true);
    }
}
